export default __webpack_public_path__ + "static/media/search.9968ec3a.svg";